import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'versailles_castle';

const supportEmail = {
	[customerGroup]: 'la-cour-des-saveurs-cv@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyBXTTMDSbE6P_Dq8S-BtmxlOIQoXB1epZE',
		authDomain: 'versaille-f289d.firebaseapp.com',
		projectId: 'versaille-f289d',
		storageBucket: 'versaille-f289d.firebasestorage.app',
		messagingSenderId: '797769042602',
		appId: '1:797769042602:web:95496d61c0db0b82added3',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '1110017883',
};
